import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { AppConfiguration } from "read-appsettings-json"
import { IsEnglish } from '../../utils/language'
import Iframe from 'react-iframe'
import i18next from 'i18next'
import { withNamespaces } from 'react-i18next'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import * as TypeHelpOnline from '../../scripts/TypeHelpOnline'
import * as storage from '../../utils/storage'
import styles from '../../styles/helpOnline.module.css'


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    titleAppBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));


function InfoLegal(props) {

    const classes = useStyles();

    const [title, setTitle] = useState('');
    const [displayDate, setDisplayDate] = useState('');
    const [contentInfo, setContentInfo] = useState('');
    const [open, setOpen] = useState(false);
    const [typeInfo, setTypeInfo] = useState(null);

    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    useEffect(() => {
        setTypeInfo(props.typeInfo);
    }, [props.typeInfo]);

    useEffect(() => {
        if (open) {
            loadContent();
            resizeForm();
        }
    }, [open]);


    const resizeForm = () => {
        setTimeout(function () {
            const element = document.querySelector('#divInfoLegal');

            const height = window.innerHeight;

            const offSet = 130;

            const customHeight = height - offSet;

            if (element !== null) {
                document.querySelector('#infoLegalFrame').style.height = `${customHeight}px`;
                document.querySelector('#infoLegalFrame').style.overflowX = 'hidden';
            }
        }, 50);
    }

    const loadContent = () => {
        let title = '';
        let displayDate = '';
        let contentInfo = '';

        if (typeInfo == TypeHelpOnline.Legal_Information) {
            title = i18next.t('helpOnline:title.legal-information');
            displayDate = storage.getShowDateStatementLegalInfo();
            contentInfo = storage.getLegalInfo();
        } else {
            title = i18next.t('helpOnline:title.termsUse-information');
            displayDate = storage.getShowDateStatementLegalInfo();
            contentInfo = storage.getTermsUse();
        }

        setTitle(title);
        setDisplayDate(displayDate);
        setContentInfo(contentInfo);
        setOpen(props.open);
    }

    const handleCloseClick = () => {
        props.handleClose();
    };

    return (
        <div id="divInfoLegal">
            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBar}>
                                {title}
                                <br />
                                {displayDate}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div id="infoLegalFrame" dangerouslySetInnerHTML={{ __html: contentInfo }}></div>
            </Dialog>
        </div>
    );
}

export default withNamespaces(['helpOnline'], { wait: true })(InfoLegal);